// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ActionMessageController from "./action_message_controller"
application.register("action-message", ActionMessageController)

import AgeRangeFilterController from "./age_range_filter_controller"
application.register("age-range-filter", AgeRangeFilterController)

import Applicant__MessageFormController from "./applicant/message_form_controller"
application.register("applicant--message-form", Applicant__MessageFormController)

import Applicant__MessagePollController from "./applicant/message_poll_controller"
application.register("applicant--message-poll", Applicant__MessagePollController)

import AutoSelectController from "./auto_select_controller"
application.register("auto-select", AutoSelectController)

import DetailListController from "./detail_list_controller"
application.register("detail-list", DetailListController)

import DialogOpenTriggerController from "./dialog_open_trigger_controller"
application.register("dialog-open-trigger", DialogOpenTriggerController)

import DirectSubmitController from "./direct_submit_controller"
application.register("direct-submit", DirectSubmitController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DismissalCookieController from "./dismissal_cookie_controller"
application.register("dismissal-cookie", DismissalCookieController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FloatButtonController from "./float_button_controller"
application.register("float-button", FloatButtonController)

import FormResetController from "./form_reset_controller"
application.register("form-reset", FormResetController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import InputPresetController from "./input_preset_controller"
application.register("input-preset", InputPresetController)

import JqueryDataTablesController from "./jquery_data_tables_controller"
application.register("jquery-data-tables", JqueryDataTablesController)

import ListController from "./list_controller"
application.register("list", ListController)

import MessagePanelController from "./message_panel_controller"
application.register("message-panel", MessagePanelController)

import PanelVisibilityController from "./panel_visibility_controller"
application.register("panel-visibility", PanelVisibilityController)

import RecruitUpdateModalController from "./recruit_update_modal_controller"
application.register("recruit-update-modal", RecruitUpdateModalController)

import Scout__OfficeChangeController from "./scout/office_change_controller"
application.register("scout--office-change", Scout__OfficeChangeController)

import Scout__ProfileImpressionController from "./scout/profile_impression_controller"
application.register("scout--profile-impression", Scout__ProfileImpressionController)

import Scout__ProfileListController from "./scout/profile_list_controller"
application.register("scout--profile-list", Scout__ProfileListController)

import Scout__SearchModalController from "./scout/search_modal_controller"
application.register("scout--search-modal", Scout__SearchModalController)

import Scout__SearchPanelStickyController from "./scout/search_panel_sticky_controller"
application.register("scout--search-panel-sticky", Scout__SearchPanelStickyController)

import ScrollToBottomController from "./scroll_to_bottom_controller"
application.register("scroll-to-bottom", ScrollToBottomController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SectionProgressController from "./section_progress_controller"
application.register("section-progress", SectionProgressController)

import SelectedAttachmentsController from "./selected_attachments_controller"
application.register("selected-attachments", SelectedAttachmentsController)

import SuddenAbsenceModalController from "./sudden_absence_modal_controller"
application.register("sudden-absence-modal", SuddenAbsenceModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import Vue__BaseController from "./vue/base_controller"
application.register("vue--base", Vue__BaseController)

import Vue__MessageTemplateController from "./vue/message_template_controller"
application.register("vue--message-template", Vue__MessageTemplateController)

import Vue__OfficeAreaController from "./vue/office_area_controller"
application.register("vue--office-area", Vue__OfficeAreaController)
